// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3UiA4","actions":"GroupTable_actions__3VpVp","deleteModalFooter":"GroupTable_deleteModalFooter__3cV_i"};